// extracted by mini-css-extract-plugin
module.exports = {"nav":"CulturesNav_nav__mtcWt","link":"CulturesNav_link__aeeDI","link--active":"CulturesNav_link--active__yTEab"};